export { default as AppConfig } from './app-config'
